import Box from '@mui/material/Box';
import { useTheme, Typography } from '@mui/material';

import { useTranslate } from 'src/locales';

import { Image } from 'src/components/image';

import { ChannelStepLayout } from '../shared/channel-step-layout';

export function Step4() {
  const { t } = useTranslate('translation');
  const theme = useTheme();

  return (
    <ChannelStepLayout title="" subtitle="">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: theme.spacing(3),
          alignItems: 'center',
        }}
      >
        <Typography
          variant="h3"
          sx={{
            textAlign: 'center',
            color: 'text.primary',
            fontWeight: theme.typography.fontWeightMedium,
          }}
        >
          {t('CHANNEL_CREATED_SUCCESSFULLY')}
        </Typography>

        <Image
          src="/assets/icons/channel/create-channel.svg"
          alt="channel svg"
          sx={{
            width: { xs: '300px', md: '400px' },
            maxWidth: '100%',
            height: 'auto',
          }}
        />
      </Box>
    </ChannelStepLayout>
  );
}
